export const STEP_PAUSE_TYPE = 'pause';

/**
 * Pause step detail
 */
export default class EQPauseStepConfig {

    /**
     * @param {number} pause duration
     */
    constructor(pause) {
        this.type = STEP_PAUSE_TYPE;
        this.pause = parseInt(pause);
        Object.freeze(this);
    }
}


// WEBPACK FOOTER //
// ./js/public-apis/onclick/EQPauseStepConfig.js